<template>
  <div v-if="isVisible" id="countdown_modal" class="countdown-modal-overlay">
    <div class="countdown-modal-dialog">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="header-content">
          <div class="header-icon">
            <i v-if="!isTimeout" class="uil-clock"></i>
            <i v-else class="uil-check-circle"></i>
          </div>
          <div class="header-text">
            <h3 class="modal-title">{{ modalTitle }}</h3>
            <p class="modal-subtitle">{{ modalDescription }}</p>
          </div>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div v-if="!isTimeout" class="countdown-section">
          <div class="countdown-display">
            <div class="countdown-circle">
              <div class="countdown-number">{{ countdownSeconds }}</div>
            </div>
          </div>
          <div class="progress-container">
            <div class="progress-bar">
              <div :style="{ width: progressPercentage + '%' }" class="progress-fill"></div>
            </div>
          </div>
        </div>

        <div v-if="isTimeout" class="timeout-section">
          <div class="timeout-icon">
            <i class="uil-check-circle"></i>
          </div>
          <div class="timeout-content">
            <p class="timeout-message">{{ $t('general.edu_auto_closed') }}</p>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <div v-if="!isTimeout" class="action-buttons">
          <button class="btn btn-continue" @click="continueSession">
            <i class="uil-play"></i>
            <span>{{ $t('general.continue') }}</span>
          </button>
        </div>

        <div v-if="isTimeout" class="action-buttons">
          <button class="btn btn-close" @click="closeModal">
            <i class="uil-times"></i>
            <span>{{ $t('general.close') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountdownModal',
  data() {
    return {
      countdownSeconds: 10,
      countdownInterval: null,
      isVisible: false,
      isTimeout: false,
      isInitialized: false
    }
  },
  computed: {
    modalTitle() {
      return this.isTimeout ? this.$t('general.edu_closed') : this.$t('general.inactivity_warning');
    },
    modalDescription() {
      return this.isTimeout
          ? this.$t('general.inactivity_page_closed')
          : this.$t('general.inactivity_page_close_warning');
    },
    progressPercentage() {
      return ((10 - this.countdownSeconds) / 10) * 100;
    }
  },
  methods: {
    show() {
      // Her açılışta state'i sıfırla
      this.resetState();
      this.isVisible = true;
      this.startCountdown();
    },

    hide() {
      this.isVisible = false;
      this.resetState();
      this.stopCountdown();
    },

    resetState() {
      // Tüm state'leri başlangıç değerlerine sıfırla
      this.countdownSeconds = 10;
      this.isTimeout = false;
      this.isInitialized = false;
      this.stopCountdown();
    },

    startCountdown() {
      // Eğer zaten bir timer çalışıyorsa, önce onu durdur
      this.stopCountdown();
      
      // State'i sıfırla
      this.countdownSeconds = 10;
      this.isTimeout = false;
      this.isInitialized = true;

      this.countdownInterval = setInterval(() => {
        // Timer'ın hala aktif olduğunu kontrol et
        if (!this.isInitialized || this.isTimeout) {
          this.stopCountdown();
          return;
        }

        this.countdownSeconds--;

        if (this.countdownSeconds <= 0) {
          this.stopCountdown();
          this.isTimeout = true;
          this.$emit('timeout'); // Ana modal kapanacak ama countdown modal açık kalacak
        }
      }, 1000);
    },

    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },

    continueSession() {
      this.hide();
      this.$emit('continue'); // İnaktivite timer yeniden başlayacak
    },

    closeModal() {
      this.hide();
    }
  },

  beforeDestroy() {
    this.stopCountdown();
  }
}
</script>

<style scoped>
.countdown-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-out;
}

.countdown-modal-dialog {
  background: white;
  border-radius: 12px;
  width: 400px;
  max-width: 95%;
  max-height: 90%;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

/* Modal Header */
.modal-header {
  background: #f8f9fa;
  padding: 20px 25px;
  border-bottom: 1px solid #e9ecef;
}

.header-content {
  display: flex;
  align-items: center;
}

.header-icon {
  font-size: 2rem;
  margin-right: 15px;
  color: #6c757d;
}

.header-text {
  flex: 1;
}

.modal-title {
  margin: 0 0 5px 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.modal-subtitle {
  margin: 0;
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 400;
}

/* Modal Body */
.modal-body {
  padding: 30px 25px;
  text-align: center;
  background: white;
}

.countdown-section {
  margin-bottom: 25px;
}

.countdown-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.countdown-circle {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.2);
}

.countdown-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1;
}

.countdown-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 3px;
}

.progress-container {
  margin-top: 15px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: #007bff;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
}

/* Timeout Section */
.timeout-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 20px;
  background: #d4edda;
  border-radius: 8px;
  border: 1px solid #c3e6cb;
}

.timeout-icon {
  font-size: 3rem;
  color: #28a745;
  margin-bottom: 15px;
}

.timeout-content {
  text-align: center;
}

.timeout-title {
  margin: 0 0 8px 0;
  font-size: 1.3rem;
  font-weight: 600;
  color: #155724;
}

.timeout-message {
  margin: 0;
  font-size: 0.9rem;
  color: #155724;
  opacity: 0.8;
}

/* Modal Footer */
.modal-footer {
  padding: 20px 25px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  width: 100%;
}

.btn {
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  min-width: 120px;
}

.btn:hover {
  opacity: 0.9;
}

.btn:active {
  transform: translateY(1px);
}

.btn-continue {
  background: #28a745;
  color: white;
}

.btn-continue:hover {
  background: #218838;
}

.btn-close {
  background: #dc3545;
  color: white;
}

.btn-close:hover {
  background: #c82333;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive styles */
@media (max-width: 480px) {
  .countdown-modal-dialog {
    width: 95%;
    margin: 10px;
    border-radius: 8px;
  }

  .modal-header {
    padding: 15px 20px;
  }

  .modal-body {
    padding: 25px 20px;
  }

  .modal-footer {
    padding: 15px 20px;
  }

  .modal-title {
    font-size: 1.3rem;
  }

  .countdown-circle {
    width: 100px;
    height: 100px;
  }

  .countdown-number {
    font-size: 2rem;
  }

  .timeout-icon {
    font-size: 2.5rem;
  }

  .btn {
    padding: 10px 20px;
    font-size: 0.85rem;
    min-width: 100px;
  }
}
</style>
